var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 15Q8.25 15 9.125 14.125Q10 13.25 10 12Q10 10.75 9.125 9.875Q8.25 9 7 9Q5.75 9 4.875 9.875Q4 10.75 4 12Q4 13.25 4.875 14.125Q5.75 15 7 15ZM7 18Q4.5 18 2.75 16.25Q1 14.5 1 12Q1 9.5 2.75 7.75Q4.5 6 7 6Q9.025 6 10.538 7.15Q12.05 8.3 12.65 10H20.6Q20.8 10 20.988 10.075Q21.175 10.15 21.3 10.275L22.275 11.25Q22.425 11.4 22.5 11.587Q22.575 11.775 22.575 11.975Q22.575 12.175 22.513 12.35Q22.45 12.525 22.3 12.675L19.7 15.275Q19.55 15.425 19.375 15.5Q19.2 15.575 19 15.575Q18.8 15.575 18.625 15.512Q18.45 15.45 18.3 15.3L17 14L15.7 15.3Q15.55 15.45 15.375 15.512Q15.2 15.575 15 15.575Q14.8 15.575 14.625 15.512Q14.45 15.45 14.3 15.3L13 14H12.65Q12.025 15.8 10.475 16.9Q8.925 18 7 18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.6eb27e39.svg";
export { ForwardRef as ReactComponent };